import DataSharingEditorView from "./DataSharingEditorView.js";
export default {
  install: molten => {
    molten.addPlugin('AttributeValueEditor', {
      name: 'assetLocators.dataSharingEnabled',
      objectType: 'assetLocators',
      create: DataSharingEditorView
    });
    molten.addPlugin('AttributeValueValidator', {
      name: 'assetLocators.dataSharingEnabled',
      objectType: 'assetLocators',
      labelDecorator: () => null
    });
    molten.addPlugin('AttributeValueEditor', {
      name: 'locator.dataSharingEnabled',
      objectType: 'locator',
      create: DataSharingEditorView
    });
    molten.addPlugin('AttributeValueValidator', {
      name: 'locator.dataSharingEnabled',
      objectType: 'locator',
      labelDecorator: () => null
    });
  }
};